import { Button } from "@heroui/button";
import { Link } from "@heroui/link";
import { cn } from "@heroui/theme";
import React from "react";

interface Props {
  className?: string;
  label?: string;
  fullWidth?: boolean;
}
const ApplyForJob = ({
  className,
  label = "Apply for Job",
  fullWidth = true,
}: Props) => {
  return (
    <Button
      as={Link}
      className={cn(
        "text-foreground-600 border-foreground-200 text-sm leading-5 tracking-[-0.084px]",
        className,
      )}
      color="primary"
      data-aos="fade-up"
      data-aos-anchor-placement="top-bottom"
      fullWidth={fullWidth}
      href="/contact-us"
      variant="bordered"
    >
      {label}
    </Button>
  );
};

export default ApplyForJob;
